import { render, staticRenderFns } from "./DialogGenericError.vue?vue&type=template&id=18a55a3f&scoped=true&"
import script from "./DialogGenericError.vue?vue&type=script&lang=js&"
export * from "./DialogGenericError.vue?vue&type=script&lang=js&"
import style0 from "./DialogGenericError.vue?vue&type=style&index=0&id=18a55a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a55a3f",
  null
  
)

export default component.exports